module.exports = __webpack_public_path__ + "static/media/example-1.0b63b008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Picton/example-1.jpg
// module id = 309
// module chunks = 0